export default {
  title: {
    'zh-cn': '态势地图',
    'zh-tw': '態勢地圖',
    'en': 'Situation Map'
  },
  // 卡片标题
  currentPlan: {
    'zh-cn': '当前套餐',
    'zh-tw': '當前套餐',
    'en': 'Current Plan'
  },
  deviceStatus: {
    'zh-cn': '设备情况',
    'zh-tw': '設備情況',
    'en': 'Device Status'
  },
  deviceAccessTrend: {
    'zh-cn': '设备接入走势',
    'zh-tw': '設備接入走勢',
    'en': 'Device Access Trend'
  },
  deviceOnlineTrend: {
    'zh-cn': '设备在线走势',
    'zh-tw': '設備在線走勢',
    'en': 'Device Online Trend'
  },
  // 套餐相关
  limitAccess: {
    'zh-cn': '限制接入',
    'zh-tw': '限制接入',
    'en': 'Limit Access'
  },
  supportSimultaneousPlay: {
    'zh-cn': '支持同时播放',
    'zh-tw': '支持同時播放',
    'en': 'Support Simultaneous Play'
  },
  bandwidth: {
    'zh-cn': '带宽',
    'zh-tw': '帶寬',
    'en': 'Bandwidth'
  },
  bandwidthWithRate: {
    'zh-cn': '（折合 {rate} Kbps 码率画面数量 {count} 个）',
    'zh-tw': '（折合 {rate} Kbps 碼率畫面數量 {count} 個）',
    'en': '( {count} screens at {rate} Kbps bitrate)'
  },
  equivalentTo: {
    'zh-cn': '折合',
    'zh-tw': '折合',
    'en': ''
  },
  bitrateScreenCount: {
    'zh-cn': '码率画面数量',
    'zh-tw': '碼率畫面數量',
    'en': 'bitrate screens'
  },
  viewPlan: {
    'zh-cn': '查看套餐',
    'zh-tw': '查看套餐',
    'en': 'View Plan'
  },
  // 设备相关
  totalDevices: {
    'zh-cn': '设备总数',
    'zh-tw': '設備總數',
    'en': 'Total Devices'
  },
  onlineDevices: {
    'zh-cn': '在线设备',
    'zh-tw': '在線設備',
    'en': 'Online Devices'
  },
  offlineDevices: {
    'zh-cn': '离线设备',
    'zh-tw': '離線設備',
    'en': 'Offline Devices'
  },
  // 其他
  comingSoon: {
    'zh-cn': '敬请期待',
    'zh-tw': '敬請期待',
    'en': 'Coming Soon'
  },
  // 单位
  unitDevice: {
    'zh-cn': '台',
    'zh-tw': '台',
    'en': ''
  },
  unitChannel: {
    'zh-cn': '路',
    'zh-tw': '路',
    'en': ''
  },
  unitCount: {
    'zh-cn': '个',
    'zh-tw': '個',
    'en': ''
  }
}

